import { useEffect, useState } from "react";
import { Cake, PartyPopper } from "lucide-react";
import UserAvatar from "@/components/UserAvatar";
import BeltBar from "@/components/BeltBar";
import { authApi } from "@/lib/api";

export default function MuralAniversariantes() {
  const [data, setData] = useState(null);

  useEffect(() => {
    authApi().get("/aniversariantes")
      .then((r) => setData(r.data))
      .catch(() => setData({ mes: "", aniversariantes: [] }));
  }, []);

  if (!data) return null;

  return (
    <section className="rounded-2xl border border-gold/30 bg-gold/[0.05] p-5 sm:p-6" data-testid="mural-aniversariantes">
      <p className="font-mono text-[10px] tracking-[0.25em] text-gold flex items-center gap-2">
        <Cake size={14} /> ANIVERSARIANTES DE {data.mes?.toUpperCase()}
      </p>
      {data.aniversariantes.length === 0 ? (
        <p className="mt-3 text-sm text-zinc-500" data-testid="mural-vazio">Nenhum aniversariante este mês.</p>
      ) : (
        <div className="mt-4 flex gap-3 flex-wrap">
          {data.aniversariantes.map((a, i) => (
            <div key={i}
              className={`flex items-center gap-3 rounded-xl border px-4 py-3 ${a.hoje ? "border-gold bg-gold/15" : "border-white/10 bg-obsidian"}`}
              data-testid={`mural-aniversariante-${i}`}>
              <UserAvatar name={a.name} photo={a.photo} birthDate={`2000-${String(new Date().getMonth() + 1).padStart(2, "0")}-01`} size="sm" testid={`mural-avatar-${i}`} />
              <div className="min-w-0">
                <p className="font-medium text-sm truncate flex items-center gap-2">
                  {a.name}
                  {a.hoje && (
                    <span className="font-mono text-[9px] tracking-wider px-2 py-0.5 rounded-full bg-gold text-obsidian inline-flex items-center gap-1" data-testid={`mural-hoje-${i}`}>
                      <PartyPopper size={10} /> É HOJE!
                    </span>
                  )}
                </p>
                <span className="flex items-center gap-2 mt-0.5 flex-wrap">
                  <span className="font-mono text-[10px] text-gold">DIA {String(a.dia).padStart(2, "0")}</span>
                  {a.idade_faz && <span className="font-mono text-[10px] text-zinc-500">FAZ {a.idade_faz} ANOS</span>}
                  <BeltBar belt={a.belt} degree={a.degree} size="sm" />
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
